<template>
  <div>
    <Table @on-sort-change="changesort" @on-selection-change="selectChange" stripe :columns="columns" :data="data"></Table>
    <div class="page-div">
      <!-- <div class="page-div-left page-div-lefts">已选 <span>{{selectNum}}</span> 条</div> -->
      <Button class="title-btn fourSize" type="success" ghost @click="goexportOrgReservationDetails">导出</Button>
      <Page :total="obj.total" @on-page-size-change="changepeoplepage" @on-change="changePeoplecurrent" show-elevator show-total :current="current" :page-size="pageSize" show-sizer class="page-div-page" />
    </div>
    <div style="clear:both;"></div>
    <Alert class="alertTitle" v-show="alertTitleIshow" show-icon type="success">操作成功</Alert>
    <Alert class="alertTitle" v-show="alertTitleIshow2" type="error" show-icon>{{ alertTitle }}</Alert>

    <!-- <Spin fix v-show="isiconfontshow">
      <span class="iconfont demo-spin-icon-load ivu-icon">&#xe71d;</span>
      <div>距离有些遥远，小简 正在努力中……</div>
    </Spin> -->
  </div>
</template>
<script>
import { selectOrgReservationDetailsForPage } from "../servers/api";
export default {
  data() {
    return {
      isiconfontshow: false,
      alertTitleIshow: false,
      alertTitleIshow2: false,
      alertTitle: "",
      selectList: [],
      selectNum: 0,
      pageSize: 20,
      current: 1,
      columns: [
        {
          title: "姓名",
          key: "patientName",
          width: 85,
          ellipsis: true,
          sortable: true,
          align: "center",
        },
        {
          title: "性别",
          key: "sex",
          width: 85,
          ellipsis: true,
          sortable: true,
          align: "center",
        },
        {
          title: "年龄",
          width: 85,
          key: "age",
          ellipsis: true,
          sortable: true,
          align: "center",
        },
        {
          title: "电话",
          key: "phone",
          width: 120,
          ellipsis: true,
          sortable: true,
          align: "center",
        },
        {
          title: "身份证号",
          key: "idCardNo",
          width: 150,
          ellipsis: true,
          sortable: true,
          align: "center",
        },
        {
          title: "套餐名称",
          key: "examSuiteName",
          width: 190,
          ellipsis: true,
          sortable: true,
          align: "center",
        },
        {
          title: "预约日期",
          key: "reservationTime",
          width: 115,
          ellipsis: true,
          sortable: true,
          align: "center",
          render: (h, params) => {
            let a = params.row.reservationTime;
            let num = "";
            if (a) {
              num = a.slice(0, 10);
            }

            return h(
              "div",
              {
                style: {
                  height: "30px",
                  "line-height": "30px",
                  "text-align": "center",
                  "font-size": "13px",
                  color: "#7F7F7F",
                },
              },
              num
            );
          },
        },
        {
          title: "预约时段",
          key: "appointmentTime",
          width: 115,
          ellipsis: true,
          sortable: true,
          align: "center",
        },
      ],
      data: [],
      isAsc: "",
      obj: {},
      tuanObj: {},
    };
  },
  methods: {
    goexportOrgReservationDetails(params) {
      //导出
      let baseUrl = sessionStorage.getItem("baseUrl");
      let token = JSON.parse(sessionStorage.getItem("login")).token || "";
      window.location.href =
        baseUrl +
        "/pms/statistical/exportOrgReservationDetails?startDate=" +
        this.tuanObj.startDate +
        "&endDate=" +
        this.tuanObj.endDate +
        "&token=" +
        token +
        "&appointmentTime" +
        this.tuanObj.appointmentTime +
        "&idOrgReservation=" +
        this.tuanObj.idOrgReservation;
    },
    selectChange(item) {
      //多选
      this.selectList = item;
      this.selectNum = this.selectList.length;
    },
    postItem(item) {
      //父组件传过来的参数
      console.log(item);
      this.tuanObj = item;
      console.log(this.tuanObj, "this.tuanObj");
      this.selectByPatientId(1);
    },
    selectByPatientId(index) {
      this.isiconfontshow = true;
      if (index) {
        this.current = 1;
      }
      let params = {
        pageNum: this.current,
        pageSize: this.pageSize,
        idOrgReservation: this.tuanObj.idOrgReservation,
        appointmentTime: this.tuanObj.appointmentTime,
        startDate: this.tuanObj.startDate,
        endDate: this.tuanObj.endDate,
        isAsc: this.isAsc,
      };
      selectOrgReservationDetailsForPage(params).then((res) => {
        if (res.data.code == 1) {
          this.isiconfontshow = false;
          this.obj = res.data.data || {};
          this.data = res.data.data.list || [];
        } else {
          this.isiconfontshow = false;
          this.alertTitle = res.data.msg;
          this.alertTitleIshow2 = true;
          this.data = [];
          setTimeout(() => {
            this.alertTitleIshow2 = false;
          }, 2000);
        }
      });
    },
    changePeoplecurrent(num) {
      //换页
      this.current = num;
      this.selectByPatientId();
    },
    changepeoplepage(num) {
      //切换条数
      this.pageSize = num;
      this.selectByPatientId(1);
    },
    changesort(itme) {
      //排序
      this.orderField = item.key;
      this.isAsc = item.order;
      this.current = 1;
      if (item.order == "normal") {
        this.isAsc = "";
        this.orderField = "";
      }
      this.selectByPatientId(1);
    },
  },
};
</script>
<style lang="scss" scoped="" type="text/css">
@import "../css/conmmon.scss";
@import "../font/iconfont.css";
.page-div {
  width: 100%;
  margin-top: 15px;
  .page-div-left {
    float: left;
    padding: 5px 10px;
  }
  .page-div-lefts {
    border-right: 1px solid #d7d7d7;
    margin-right: 15px;
  }
  .page-div-page {
    float: right;
    margin-right: 15px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/tan/yuallsee.vue